import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, take, takeLast } from 'rxjs';
import { ConnectionService } from 'src/app/shared/services/connection/connection.service';
import { Addresses } from '../../entity/address';
import { AppConstants } from '../../entity/constants';
import { ErrorMessage } from '../../entity/error.const';
import { UpdateAddressCommand } from '../../entity/utility-interfaces';
import { CommandType } from '../../entity/enums';

import { DataRepositoryService } from '../../services/data-repository/data-repository.service';
import { TaskInfoService } from '../../services/task-info/task-info.service';
import { HttpStatusCode } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class UpdateAddressService {

  filteredOptions: any = [];

  notifyError: BehaviorSubject<string> = new BehaviorSubject('')
  notifyError$ = this.notifyError.asObservable();

  addressData = {} as Addresses;
  updateAddressData: UpdateAddressCommand[] = [];
  isLoadMap: boolean = false;

  updateAddressSuccess: Subject<any> = new Subject;

  constructor(
    private connectionService: ConnectionService
    , private dataRepositoryService: DataRepositoryService
    , private taskInfoService: TaskInfoService
  ) { }



  /**
   * *****************Address search and update operations***************** 
   */

  /**
   * Method performs the searching of address with input text value 
   * by callig address API to obtain possible matches of the input text 
   * @param val searching text value
   */
  getSearchResults(val: any) {
    if (val != undefined && val !== '' && val.length >= 2) {
      const queryParams: any = {
        text: typeof (val) === 'object' ? val.properties.label : val
      };
      this.connectionService.httpReq({
        reqType: AppConstants.GETREQUEST,
        endUrl: '',
        directoryType: AppConstants.Address,
        data: queryParams
      }).subscribe({
        next: (resp: any) => {
          this.filteredOptions = resp.features;
        },
        error: (error: any) => {
          this.filteredOptions = [];
        }
      })
    }
  }


  /**
    * To get the addressDetails by providing the free text 
    * @param searchText User Input searched text
    */
  searchAddress(searchText: string): Observable<any> {
    let resultantAddress = new Subject<any>;
    let addressData = {} as Addresses;
    this.connectionService.httpReq({
      reqType: AppConstants.GETREQUEST,
      endUrl: `${AppConstants.ADDRESSPOINT}/${searchText}`,
      directoryType: AppConstants.V4
    }).pipe(takeLast(1)).subscribe({
      next: (resp: any) => {
        this.showError('')
        if (resp?.addresses.length) {
          addressData = resp?.addresses[0];
        } else {
          this.addressData = {} as Addresses;
        }
      },
      error: (err: any) => {
        this.showError(ErrorMessage.ADDRESSNOTFOUND)
        this.addressData = {} as Addresses;
      }
      , complete: () => {
        resultantAddress.next(addressData);
        resultantAddress.complete();
      }
    })
    return resultantAddress.asObservable();
  }

  /**
   * Method get the input error message and emits to subscribers
   * @param errorMessage Error message to be shown on UI
   */
  showError(errorMessage: string) {
    this.notifyError.next(errorMessage);
  }

  /**
   * Method forms an object for updating the address to the task and
   * assigns to updateAddrssData object.
   * @param address address details
   * @param taskId selected task's task-ID
   */
  formUpdateAddressObject(address: any, taskId: string) {
    this.updateAddressData = [{
      address_id: address.address_id,
      command_type: CommandType.UpdateAddressCommand,
      id: crypto.randomUUID(),
      task_id: taskId ?? '',
      timestamp: new Date(),
      user_id: this.dataRepositoryService.loggedInUser.username ?? ''
    }]
  }

  /**
   * Methods submits the address updated and calls the command API for address
   * by passing the updated address object and post the API call, it calls
   * delta of active tab.
   */
  submitAddress(): Observable<any> {
    let submitAddress = new Subject<any>;
    let addressupdateSuccessfull: boolean = false;
    try {
      this.connectionService.httpReq({
        reqType: AppConstants.POSTREQUEST,
        endUrl: AppConstants.Command,
        directoryType: AppConstants.DP,
        data: this.updateAddressData
      }
      ).pipe(take(1)).subscribe({
        next: (res: any) => {
          this.updateAddressSuccess.next(true);
          addressupdateSuccessfull = true;
        }
        , error: (error: any) => {
          if (error.status === HttpStatusCode.Forbidden) {
            this.updateAddressSuccess.next(error); 
          } else {
            this.updateAddressSuccess.next(false);
          }
        }
        , complete: () => {
          submitAddress.next(addressupdateSuccessfull);
          submitAddress.complete();
        }
      })
    }
    catch (err) { }

    return submitAddress.asObservable();
  }

}


